import axios from 'axios'
import { store } from '@/store/index.js'
import { getAuthProvider } from '@/oidc-config.js'

// PROD api: https://api.apidm.cs.scania.com
// DEV api:  https://api.dm.csawsdev.net
const getAuthorizationHeader = () => {
  const provider = getAuthProvider(store.state.oidc?.user)
  
  const token = provider === 'SCANIA'
   ? store.state.bearerToken
   : store.state.oidc?.access_token ?? store.state.bearerToken

  if (!token) {
   return {}
  }

  const authToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`
  return { Authorization: authToken }
}

const getJsonOutput = async (fileName) => {
  const response = await axios.get(
   'https://api.apidm.cs.scania.com' + '/v1/jsonOutput?fileName=' + fileName,
   {
     headers: {
       'Content-Type': 'application/json',
       Accept: 'application/json',
       ...getAuthorizationHeader()
     }
   }
  ).then((response) => {
   return response
  }).catch((error) => {
   console.log('API error: ' + error)
  })
  return response
}

const getDemoFiles = async (datasetId) => {
  const response = await axios.get(
   'https://api.apidm.cs.scania.com' + '/v1/raw-data-archive/' + datasetId,
   {
     headers: {
       ...getAuthorizationHeader()
     }
   }
  ).then((response) => {
   return response
  }).catch((error) => {
   console.log('ERROR: ' + JSON.stringify(error.response?.data))
   return error.response?.data
  })
  return response
}

const orderReadout = async (body) => {
  const response = await axios.post('https://api.apidm.cs.scania.com/v1/order-readout', body, {
   headers: {
     'Content-Type': 'application/json',
     Accept: 'application/json',
     ...getAuthorizationHeader()
   }
  }).then((response) => {
   return response
  }).catch((error) => {
   console.log('Order Readout error: ' + error)
  })
  return response
}

const orderReadoutOPM = async (body) => {
  const response = await axios.post('https://api.apidm.cs.scania.com/v1/readout-requests', body, {
   headers: {
     'Content-Type': 'application/json',
     Accept: 'application/json',
     ...getAuthorizationHeader()
   }
  }).then((response) => {
   return response
  }).catch((error) => {
   console.log('ERROR: ' + error)
  })
  return response
}

// Get readout user request status
const getOrderReadoutOPM = async (productId) => {
  const response = await axios.get(
   'https://api.apidm.cs.scania.com' + '/v1/get-readout-requests/' + productId,
   {
     headers: {
       ...getAuthorizationHeader()
     }
   }
  ).then((response) => {
   return response
  }).catch((error) => {
   console.log('ERROR: ' + JSON.stringify(error.response?.data))
   return error.response?.data
  })
  return response
}

const requestConfiguration = async (body) => {
  const response = await axios.put('https://api.apidm.cs.scania.com/v1/request-configuration', body, {
   headers: {
     'Content-Type': 'application/json',
     Accept: 'application/json',
     ...getAuthorizationHeader()
   }
  }).then((response) => {
   return response
  }).catch((error) => {
   console.log('Request configuration error: ' + error)
  })
  return response
}

export {
  getJsonOutput,
  orderReadout,
  requestConfiguration,
  orderReadoutOPM,
  getOrderReadoutOPM,
  getDemoFiles
}
